// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { versions } from './versions';

const version = versions ? versions : null;

// Disable whitespace linting so powershell interpolation will not break the build
/* tslint:disable whitespace */
export const environment = {
envname:'UAT',
baseUrl:'https://uateproveapi.advanc-ed.org/ses-api/v1',
production: false,
  version
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
